import { styled } from '@linaria/react';

export const Block = styled.div<{ gap?: number; align?: string }>`
	display: flex;
	flex-direction: column;
	align-items: ${({ align = 'left' }) => align};
	row-gap: ${({ gap = 16 }) => `${gap}px`};
	width: 100%;
`;
